<template>
  <div class="mod-org__employee">
    <el-row class="search-box">
      <div class="search-box-left flex-grow">
        <el-form :inline="true"
                 :model="dataForm"
                 @keyup.enter.native="getDataList(1)">
          <el-form-item label="员工姓名：">
            <el-input v-model="dataForm.name"
                      placeholder="姓名模糊搜索"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="手机号：">
            <el-input v-model="dataForm.mobile"
                      placeholder="精准搜索"
                      clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="getDataList(1)">{{ $t('query') }}</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button v-if="$hasPermission('sys:user:export')" type="primary" @click="exportHandle()">{{ $t('export') }}</el-button>
          </el-form-item> -->
        </el-form>
      </div>
      <div class="search-box-right flex-shrink">
        <el-button type="primary"
                   @click="inviteJoinHandle()">邀请新员工加入</el-button>
      </div>
    </el-row>
    <div class="user-manage">
      <div class="org-card">
        <el-card class="aui-card--fill">
          <div slot="header">
            <span>部门组织</span>
          </div>
          <!-- :props="defaultProps" -->
          <el-tree :data="orgTree"
                   @node-click="handleNodeClick"
                   :current-node-key="dataForm.orgId"
                   :props="{ label: 'orgName', children: 'children' }"
                   :highlight-current="true"
                   node-key="orgId">
            <span class="custom-tree-node"
                  slot-scope="{ node, data }">
              <span style="float: left;margin-right: 5px;">{{ data.orgName }}</span>
              <el-popover placement="top-start"
                          width="200"
                          trigger="hover">
                <span style="float: right; color: #2e88ff; font-size: 13px"
                      slot="reference">编辑</span>
                <div>
                  <div v-show="node.level < 5">
                    <el-button class="text-button-padding"
                               type="text"
                               @click="addDeptHandle(data)">新建子部门</el-button>
                  </div>
                  <!-- <div>
                    <el-button class="text-button-padding" type="text" @click="addUserHandle('', data.id)">新增员工</el-button>
                  </div> -->
                  <div>
                    <el-button class="text-button-padding"
                               v-show="node.level !== 1"
                               type="text"
                               @click="updateDeptHandle(data)">编辑部门</el-button>
                  </div>
                  <div>
                    <el-button class="text-button-padding"
                               v-show="node.level !== 1"
                               type="text"
                               @click="deleteOrgHandle(data, node)">删除部门</el-button>
                  </div>
                </div>
              </el-popover>
            </span>
          </el-tree>
          <org-add-or-Update v-if="orgVisible"
                             ref="orgAddOrUpdate"
                             @refreshDataList="getOrgTree"></org-add-or-Update>
        </el-card>
      </div>
      <div class="user-card">
        <el-card shadow="never">
          <el-table v-loading="dataListLoading"
                    :data="dataList"
                    border
                    style="width: 100%; max-width: 100%;">
            <template slot="empty">
              <img src="@/assets/img/good/noGood.png">
              <div>暂无数据</div>
            </template>
            <el-table-column type="index"
                             label="序号"
                             header-align="center"
                             align="center"
                             width="50"></el-table-column>
            <el-table-column prop="code"
                             label="员工编号"
                             header-align="center"
                             align="center"></el-table-column>
            <el-table-column prop="name"
                             label="姓名"
                             header-align="center"
                             align="center"></el-table-column>
            <el-table-column prop="orgName"
                             label="部门"
                             header-align="center"
                             align="center"></el-table-column>
            <el-table-column prop="postName"
                             label="岗位"
                             header-align="center"
                             align="center"></el-table-column>
            <el-table-column prop="userName"
                             label="账号"
                             header-align="center"
                             align="center"></el-table-column>
            <el-table-column prop="mobile"
                             label="手机号"
                             header-align="center"
                             align="center"></el-table-column>
            <el-table-column prop="createTime"
                             label="创建时间"
                             header-align="center"
                             align="center"></el-table-column>
            <el-table-column :label="$t('handle')"
                             header-align="center"
                             align="center"
                             width="150">
              <template slot-scope="scope">
                <el-button type="text"
                           size="small"
                           @click="detailUserHandle(scope.row)">查看</el-button>
                <el-button type="text"
                           size="small"
                           @click="updateUserHandle(scope.row)">{{ $t('update') }}</el-button>
                <el-button type="text"
                           size="small"
                           @click="setPostHandle(scope.row)">设置岗位</el-button>
                <el-button type="text"
                           size="small"
                           @click="resetPassWordHandle(scope.row)">重置密码</el-button>
                <el-button type="text"
                           size="small"
                           @click="dimissionHandle(scope.row)">设为离职</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination :current-page="page"
                         :page-sizes="[10, 20, 50, 100]"
                         :page-size="limit"
                         :total="total"
                         layout="total, sizes, prev, pager, next, jumper"
                         @size-change="pageSizeChangeHandle"
                         @current-change="getDataList">
          </el-pagination>
          <!-- 弹窗, 新增 / 修改 -->
          <employee-update v-if="employeeUpdateVisible"
                           ref="employeeUpdate"
                           @refreshDataList="getDataList"></employee-update>
          <!-- 设置岗位 -->
          <employee-post v-if="employeePostVisible"
                         ref="employeePost"
                         @refreshDataList="getDataList"></employee-post>
          <!-- 重置密码 -->
          <employee-reset-password v-if="resetPassWordVisible"
                                   ref="employeeResetPassword"></employee-reset-password>
          <!-- 离职 -->
          <employee-leave v-if="employeeLeaveVisible"
                          ref="employeeLeave"
                          @refreshDataList="getDataList"></employee-leave>
        </el-card>
      </div>
    </div>
    <!-- 邀请新员工加入 -->
    <el-dialog :visible="inviteJoinVisible"
               title="邀请新员工加入"
               :show-close="false">
      <div class="invite-join-content">
        <!-- <div>邀请链接：</div> -->
        <el-row>邀请链接：</el-row>
        <el-row>
          <el-input v-model="inviteJoinUrl"
                    disabled
                    style="width: 80%"></el-input>
          <el-button @click="copeUrlHandle()"
                     v-show="inviteJoinUrl">复制链接</el-button>
        </el-row>
        <el-row>邀请链接有效期为30天</el-row>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="inviteJoinVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import OrgAddOrUpdate from './org-add-or-update'
import EmployeeUpdate from './employee-update'
import EmployeeResetPassword from './employee-reset-password'
import EmployeeLeave from './employee-leave'
import EmployeePost from './employee-post'
export default {
  data () {
    return {
      dataListLoading: false,
      dataForm: {
        name: '',
        username: '',
        orgId: '',
        mobile: ''
      },
      orgTree: [], // 组织机构树
      dataList: [], // 员工列表
      // 分页
      page: 1,
      limit: 10,
      total: 0,
      // 编辑用户
      employeeUpdateVisible: false,
      // 部门
      orgVisible: false,
      // 重置密码
      resetPassWordVisible: false,
      // 员工离职
      employeeLeaveVisible: false,
      // 邀请
      inviteJoinVisible: false,
      inviteJoinUrl: '',
      // 设置岗位
      employeePostVisible: false,
      postVisible: false,
      roleList: [],
      setPostForm: {},
      dataRule: {}
    }
  },
  mounted () {
    this.getOrgTree()
  },
  components: {
    OrgAddOrUpdate,
    EmployeeResetPassword,
    EmployeeLeave,
    EmployeeUpdate,
    EmployeePost
  },
  methods: {
    // 查询员工列表数据
    getDataList (page = this.page) {
      if (this.dataListLoading) {
        return false
      }
      this.dataListLoading = true
      this.page = page
      this.$http.post(`/front/consumer/custorg/custUserList`,
        {
          page: this.page,
          limit: this.limit,
          companyId: this.$store.state.user.defaultCompanyId,
          ...this.dataForm
        }
      ).then(({ data: res }) => {
        this.dataListLoading = false
        if (res.code !== 0) {
          this.dataList = []
          this.total = 0
          return false
        }
        this.dataList = res.data.data || []
        this.total = res.data.count || 0
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    // 邀请新员工加入
    inviteJoinHandle () {
      this.inviteJoinVisible = true
      this.$http.post(`/front/consumer/custorg/generateInvitationLink/${this.$store.state.user.defaultCompanyId}`)
        .then(({ data: res }) => {
          this.inviteJoinUrl = res.data
        }).catch(() => { })
    },
    // 复制链接
    copeUrlHandle () {
      // try {
      let input = document.createElement('input') // 直接构建input
      input.value = this.inviteJoinUrl // 设置内容
      document.body.appendChild(input) // 添加临时实例
      input.select() // 选择实例内容
      document.execCommand('Copy') // 执行复制
      document.body.removeChild(input) // 删除临时实例
      this.$message.success('复制成功')
      // } catch {
      //   this.$message.error('请重新复制')
      // }
    },
    // 获取组织机构树
    getOrgTree () {
      this.$http.get(`/front/consumer/custorg/list`, {
        params: {
          orgName: '',
          orgCode: '',
          companyId: this.$store.state.user.defaultCompanyId
        }
      })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.orgTree = []
            return false
          }
          this.orgTree = res.data || []
        }).catch(() => {
        })
    },
    // 点击组织机构 查询用户列表
    handleNodeClick (data) {
      this.dataForm.orgId = data.orgId
      this.getDataList(1)
    },
    // 新建子部门
    addDeptHandle (data) {
      // console.log(data, 'data', node)
      this.orgVisible = true
      this.$nextTick(() => {
        this.$refs.orgAddOrUpdate.dataForm.parentId = data.orgId
        this.$refs.orgAddOrUpdate.dataForm.orgId = ''
        this.$refs.orgAddOrUpdate.dataForm.orgName = ''
        this.$refs.orgAddOrUpdate.dataForm.orgSort = data.children ? data.children.length : 0
        this.$refs.orgAddOrUpdate.init()
      })
    },
    // 编辑部门
    updateDeptHandle (data) {
      this.orgVisible = true
      this.$nextTick(() => {
        this.$refs.orgAddOrUpdate.dataForm.parentId = ''
        this.$refs.orgAddOrUpdate.dataForm.orgId = data.orgId
        this.$refs.orgAddOrUpdate.dataForm.orgName = data.orgName
        this.$refs.orgAddOrUpdate.dataForm.orgSort = data.orgSort || 0
        this.$refs.orgAddOrUpdate.init()
      })
    },
    // 删除部门
    deleteOrgHandle (data, node) {
      this.$confirm(`确认删除${data.orgName}, 及其下属部门？`, {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        // 删除
        this.$http.post(`/front/consumer/custorg/deleteCustSysOrg`, { orgId: data.orgId })
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            }
            this.$message.success(res.message)
            this.getOrgTree()
          }).catch(() => {
          })
      })
    },
    // 查看详情
    detailUserHandle (row) {
      this.$router.push({
        name: 'organizationEmployeeDetail',
        query: {
          eId: row.custId
        }
      })
    },
    // 编辑员工
    updateUserHandle (row) {
      this.employeeUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.employeeUpdate.dataForm.custId = row.custId
        this.$refs.employeeUpdate.orgTree = this.orgTree
        this.$refs.employeeUpdate.init()
      })
    },
    // 设置员工岗位
    setPostHandle (row) {
      this.employeePostVisible = true
      this.$nextTick(() => {
        this.$refs.employeePost.dataForm.custId = row.custId
        this.$refs.employeePost.init()
      })
    },
    // 重置密码
    resetPassWordHandle (row) {
      this.resetPassWordVisible = true
      this.$nextTick(() => {
        this.$refs.employeeResetPassword.dataForm.custId = row.custId
        this.$refs.employeeResetPassword.dataForm.name = row.name
        this.$refs.employeeResetPassword.init()
      })
    },
    // 离职
    dimissionHandle (row) {
      this.employeeLeaveVisible = true
      this.$nextTick(() => {
        this.$refs.employeeLeave.dataForm.custId = row.custId
        this.$refs.employeeLeave.dataForm.name = row.name
        this.$refs.employeeLeave.init()
      })
    },
    // 改变每页条数
    pageSizeChangeHandle (val) {
      this.limit = val
      this.getDataList(1)
    }
  }
}
</script>
<style lang='scss' scoped>
.mod-org__employee {
  .user-manage {
    display: flex;
    .org-card {
      flex-shrink: 0;
      margin-right: 5px;
      min-width: 150px;
      max-width: 40%;
    }
    .user-card {
      flex-grow: 1;
      overflow: auto;
    }
  }
}
</style>
